import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_CRITICAL, PASTE_COMMAND } from 'lexical';
import { useEffect } from 'react';

/**
 * When pasting, only pass up the plain text version of the clipboard in order to avoid pasting rich text.
 */
export function PlainPastePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (e: ClipboardEvent) => {
        if (!e.clipboardData) return false;

        if (e.clipboardData.types.includes('text/html')) {
          // If we detect potential rich text, ignore it and pass up the plain text version
          const plainText = e.clipboardData.getData('text/plain').trim();
          e.preventDefault();
          e.stopPropagation();

          const plainPasteEvent = new ClipboardEvent('paste', {
            bubbles: true,
            cancelable: true,
            clipboardData: new DataTransfer(),
          });
          plainPasteEvent.clipboardData?.setData('text/plain', plainText);
          e.target?.dispatchEvent(plainPasteEvent);
          return true;
        }
        return false;
      },
      COMMAND_PRIORITY_CRITICAL,
    );
  }, [editor]);

  return undefined;
}
